import React from 'react'
import Proptypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { toggleScenarioDialog } from '../../actions'
import { styled } from '@mui/material/styles'

const classes = {
  container: `new-scenario-button`,
}
const Container = styled('div')({
  [`&.${classes.container}`]: {
    cursor: 'pointer',
  },
})

const NewScenario = () => {
  const dispatch = useDispatch()

  const click = () => {
    dispatch(toggleScenarioDialog())
  }

  return (
    <Container className={classes.container} onClick={click}>
      New Scenario
    </Container>
  )
}
NewScenario.propTypes = {
  auth: Proptypes.object,
}
export default NewScenario
